import { useState, useCallback } from "react";
import { useQuery, useQueryClient, useMutation } from "react-query";
import { useLocalStorage } from "react-use";
import { makeAuthedRequest } from "shared/utils/makeAuthedRequest";
import { createContainer } from "unstated-next";

import { SORT_TYPE } from "shared/enums";
import { toast } from "react-toastify";

function useContacts({ archived }) {
  const queryClient = useQueryClient();
  const [searchTerm, setSearchTerm] = useState("");
  const [filterType, setFilterType] = useState(null);
  const [sortType, setSortType] = useLocalStorage(
    "sortType",
    SORT_TYPE.NameAsc
  );

  const { isLoading, isError, data, error, isPreviousData } = useQuery(
    ["/contacts", searchTerm, filterType, sortType, archived],
    () => {
      let path = "/contacts";

      const query = [
        ["sortBy", sortType],
        //searchTerm && ["searchTerm", searchTerm],
        filterType && ["filterBy", filterType],
        archived && ["archived", "true"],
      ];

      path += "?";
      path += query
        .filter((pair) => pair)
        .map((pair) => `${pair[0]}=${encodeURIComponent(pair[1])}`)
        .join("&");

      return makeAuthedRequest(path).then(async (res) => {
        const json = await res.json();

        if (res.ok) {
          return json.data;
        } else {
          console.error(json);
          throw new Error("Request failed");
        }
      });
    },
    {
      keepPreviousData: true,
    }
  );

  const createContactMutation = useMutation(
    (contact) =>
      makeAuthedRequest("/contacts", {
        method: "post",
        body: JSON.stringify({
          id: contact.id,
          name: contact.name,
          email: contact.email,
          phone: contact.phone,
          type: contact.type,
        }),
      }).then(async (res) => {
        if (!res.ok) {
          const json = await res.json();
          if (json.errors?.length > 0) {
            throw new Error(json.errors[0].message);
          }
        }

        return res;
      }),
    {
      onSettled: () => {
        queryClient.invalidateQueries("/contacts");
      },
    }
  );

  return {
    archived,

    isLoading,
    isError,
    isPreviousData,
    data,
    error,

    searchTerm,
    setSearchTerm,
    filterType,
    setFilterType,
    sortType,
    setSortType,

    createContactMutation,
  };
}

export const ContactsContainer = createContainer(useContacts);
